import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import AboutUS from "./pages/AboutUs";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import Checkout from "./pages/Checkout";
import Cart from "./pages/Cart";
import ContactUs from "./pages/ContactUs";
import FindMe from "./pages/FindMe";
import { Provider } from "react-redux";
import store from "./Redux/store";
import Signup from './pages/Signup';
import Signin from './pages/Login';
import SuccessPage from './pages/SuccessPage';
import PaymentScreen from './pages/PaymentScreen';
import Profile from './pages/Profile';
import Navbar from './Componenets/Navbar';
import FavouritesPage from './pages/FavouritesPage';
import PrivacyPolicy from './pages/PrivacyPolicy'

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    // User not logged in, redirect to login page
    return <Navigate to="/signin" replace />;
  }
  return children;
};

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Product" element={<Product />} />
            <Route path="/AboutUS" element={<AboutUS />} />
            <Route path="/Checkout" element={<Checkout />} />
            <Route path="/Cart" element={<Cart />} />
            <Route path="/ContactUs" element={<ContactUs />} />
            <Route path="/FindMe" element={<FindMe />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/paymentconfirmation" element={<PaymentScreen />} />
            <Route path="/payment_successfull" element={<SuccessPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route 
              path="/userDashboard" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route path="/Shop" element={<Shop />} />
            <Route path="/favourites" element={<FavouritesPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </Provider>
  );
}

export default App;